module.exports = __webpack_public_path__ + "media/images/autopilot/setup_step_3_wl-91de66e4e7cf70f8f6dee9d896984319.svg";